import { highlightBlueDark10, white, fontFamilyOpenSans, black, argoGold, grayLight20, grayLight40 } from './principles'

const commonTheme = {
    fontFamily: 'Montserrat, sans-serif',
}

export const themes = {
  acura: {
    ...commonTheme,
    color: '#e6231e'
  },
  bmw: {
    ...commonTheme,
    fontFamily: fontFamilyOpenSans,
    color: '#1d69d4'
  },
  desert: {
    ...commonTheme,
    color: '#a4031f'
  },
  lucid: {
    backgroundColor: 'rgba(240, 240, 240, 1)',
    fontFamily: 'Public Sans, system-ui',
    fontWeight: 400,
    color: '#d7be96'
  },
  honda: {
    ...commonTheme,
    fontFamily: fontFamilyOpenSans,
    color: '#007cc3'
  },
  hyundai: {
    ...commonTheme,
    fontFamily: fontFamilyOpenSans,
    color: '#333333'
  },
  kia: {
    ...commonTheme,
    fontFamily: fontFamilyOpenSans,
    color: '#05141F'
  },
  melon: {
    ...commonTheme,
    fontFamily: fontFamilyOpenSans,
    color: '#fe218f'
  }
}

const commonFooterTheme = {
  fontFamily: 'Montserrat, sans-serif',
  borderRadius: '4px',
  buttonHeight: 48,
  fontSize: 18,
  rightButtonDisabled: {
    opacity: 0.3
  },
  hoverShadow: 'rgba(0 0 0 / 20%) 0px 10px 20px',
  transition: 'all 0.2s ease-in-out',
}

export const navFooterThemes = {
  acura: {
    ...commonFooterTheme,
    backgroundColor: '#000000',
    fontWeight: 800,
    borderWidth: '2px',
    leftButtonColors: ['#FFFFFF', '#000000', '#e6231e'], // text color, background color, border color
    rightButtonColors: ['#e6231e', '#FFFFFF', '#e6231e', '#FFFFFF'] // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
  },
  bmw: {
    ...commonFooterTheme,
    fontFamily: fontFamilyOpenSans,
    fontWeight: 400,
    leftButtonColors: ['#FFFFFF', '#1d69d4', '#1d69d4'], // text color, background color, border color
    rightButtonColors: ['#1d69d4', '#FFFFFF', '#1d69d4', '#FFFFFF'] // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
  },
  desert: {
    ...commonFooterTheme,
    fontWeight: 800,
    borderRadius: '0px',
    leftButtonColors: ['#000000', '#feb95f', '#feb95f'], // text color, background color, border color
    rightButtonColors: ['#feb95f', '#000000', '#feb95f', '#000000'] // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
  },
  lucid: {
    ...commonFooterTheme,
    fontFamily: 'Public Sans, system-ui',
    fontWeight: 400,
    leftButtonColors: ['#FFFFFF', '#000000', '#000000'], // text color, background color, border color
    rightButtonColors: ['#000000', '#FFFFFF', '#000000', '#FFFFFF'], // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
    textTransform: 'uppercase'
  },
  argo: {
    ...commonFooterTheme,
    backgroundColor: '#2B5195',
    leftButtonColors: [white, '#006BC2', '#006BC2'], // text color, background color, border color
    rightButtonColors: [argoGold, black, argoGold, black], // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
    rightButtonDisabled: {
      color: '#14284C',
      backgroundColor: '#696A5B',
      borderColor: '#696A5B'
    }
  },
  honda: {
    ...commonFooterTheme,
    backgroundColor: '#007cc3',
    fontWeight: 800,
    borderWidth: '2px',
    borderColor: '#FFFFFF',
    leftButtonColors: ['#FFFFFF', '#007cc3', '#FFFFFF'], // text color, background color, border color
    rightButtonColors: ['#007cc3', '#FFFFFF', '#007cc3', '#FFFFFF'], // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
    rightButtonDisabled: {
      backgroundColor: '#007cc3',
      opacity: 0.3
    }
  },
  hyundai: {
    ...commonFooterTheme,
    backgroundColor: '#333333',
    fontWeight: 800,
    borderWidth: '2px',
    borderColor: '#FFFFFF',
    leftButtonColors: ['#FFFFFF', '#333333', '#FFFFFF'], // text color, background color, border color
    rightButtonColors: ['#333333', '#FFFFFF', '#333333', '#FFFFFF'], // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
    rightButtonDisabled: {
      backgroundColor: '#333333',
      opacity: 0.3
    }
  },
  kia: {
    ...commonFooterTheme,
    backgroundColor: '#05141F',
    fontWeight: 600,
    borderWidth: '2px',
    borderColor: '#FFFFFF',
    leftButtonColors: ['#FFFFFF', '#05141F', '#FFFFFF'], // text color, background color, border color
    rightButtonColors: ['#05141F', '#FFFFFF', '#05141F', '#FFFFFF'] // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
  },
  melon: {
    ...commonFooterTheme,
    backgroundColor: '#FFFFFF',
    fontWeight: 800,
    leftButtonColors: ['#000000', '#fe218f', '#fe218f'], // text color, background color, border color
    rightButtonColors: ['#fe218f', '#000000', '#fe218f', '#000000'], // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
    borderRadius: '100px',
    width: '112px',
    padding: '25px 25px'
  },
  default: {
    backgroundColor: highlightBlueDark10,
    fontFamily: fontFamilyOpenSans,
    borderRadius: '4px',
    buttonHeight: 40,
    fontSize: 16,
    leftButtonColors: [white, '', white], // text color, background color, border color
    rightButtonColors: [white, highlightBlueDark10, '#26A843', white], // border/ background color, text color, onClickSubmit background color, onClickSubmit text color
    rightButtonDisabled: {
      color: grayLight20,
      backgroundColor: grayLight40,
      borderColor: '#0057b5'
    }
  }
}

export const getNavFooterTheme = ({ theme, shouldShowOfferCreationComponent }) => {
  if (shouldShowOfferCreationComponent) {
    return navFooterThemes[theme] || navFooterThemes.argo
  } else {
    return navFooterThemes.default
  }
}

export const getTheme = theme => {
  if (!theme) return
  return themes[theme]
}
